import { EVENTS as E } from '../core/constants';
import { normalizeCurrencyCodeForMeta, normalizePurchaseAmountForMeta } from '../core/utils';

type BingEventParams = Record<string, string | number>;

interface BingEvent {
  action: string;
  params?: BingEventParams;
}

const BING_EVENTS_BY_ANALYTICS_EVENT: Record<string, BingEvent> = {
  [E.SESSION_START]: { action: 'ob_start' },
  [E.LEAD]: { action: 'signup' },
  [E.CHECKOUT_SCREEN_LOAD]: {
    action: 'begin_checkout',
    params: { event_label: 'begin_checkout', event_category: 'begin_checkout' },
  },
};

const pushBingEvent = ({ action, params = {} }: BingEvent) => {
  window.uetq = window.uetq || [];
  window.uetq.push('event', action, params);
};

export const sendBingFunnelEvent = (eventName: string) => {
  const bingEvent = BING_EVENTS_BY_ANALYTICS_EVENT[eventName];
  if (bingEvent) pushBingEvent(bingEvent);
};

export const sendBingPurchaseEvent = ({
  price,
  currency,
  eventId,
}: {
  price: number;
  currency?: string;
  eventId: string;
}) => {
  pushBingEvent({
    action: 'purchase',
    params: {
      event_label: 'purchase',
      event_category: 'purchase',
      revenue_value: normalizePurchaseAmountForMeta(price),
      currency: normalizeCurrencyCodeForMeta(currency),
      event_id: eventId,
    },
  });
};
